import L from 'leaflet';

export const markerIcon = L.icon({
  className: 'map__marker',
  iconUrl: '/front_assets/img/map/pin.svg',
  iconSize: [32, 47],
  iconAnchor: [16, 47],
  popupAnchor: [-3, -76],
});

export const popup = (data) => {
  const div = document.createElement('div');
  div.className = 'map__popup user';
  div.setAttribute('data-target', 'map.popup');
  div.setAttribute('tabindex', 0);

  let specializations = '';

  if (typeof data.specializations !== 'undefined') {
    specializations += '<div class="mt-3 mt-md-4"><div class="mt-n2">';

    Object.values(data.specializations).forEach((specialization) => {
      specializations += `
        <div class="label label--sm label--rounded font-weight-normal mt-2 mx-2">
          ${specialization}
        </div>
      `;
    });

    specializations += '</div></div>';
  }

  div.innerHTML = `
    <div class="user__content">
      <button class="map__popup-close btn--reset" type="button" data-action="click->map#closePopup">
        <svg class="icon icon-times" aria-hidden="true"><use xlink:href="#icon-times"></use></svg>
        <span class="sr-only">Close</span>
      </button>

      <img
        data-src="${data.image}"
        alt="${data.name}"
        width="74"
        class="img-fluid img--rounded mx-auto lazyload"
        loading="lazy"
      >

      <div class="font-secondary color-secondary mt-3 mt-md-4">
        ${data.name}
      </div>

      <div class="d-flex align-items-center justify-content-center color-secondary">
        <span class="mr-3 mr-md-4">${data.city}</span>
        <span>${data.grade}</span>
      </div>

      ${specializations}
    </div>

    <a href="${data.url}" class="user__button btn mt-auto" role="button">
      ${window.app.i18n.viewProfile} <svg class="icon icon-arrow-right ml-2" aria-hidden="true"><use xlink:href="#icon-arrow-right"></use></svg>
    </a>
  `;

  return div;
};
